import React from 'react';
import cn from 'classnames';
import { Route, Switch } from 'react-router';
import useToggle from 'src/hooks/useToggle';
// Components
import DarkOverlay from 'HTKit/Elements/DarkOverlay';
import { QuestionAnswerDisplay } from 'src/containers/AddSkuPage/QuestionsFlowPage/Parts/QAPage';
import { QAProvider } from 'src/containers/AddSkuPage/QuestionsFlowPage/Context';
import { SkuHeader } from 'src/containers/AddSkuPage/QuestionsFlowPage/Parts';
// Constants
import { QUESTIONS_FLOW_CONTAINER_ID } from './constants';
// styles
import styles from './styles.scss';

const QuestionsFlowPage = () => {
  const { toggleState: showOverlay, toggle: toggleOverlay } = useToggle(false);
  const containerStyles = cn('site-v2', styles.container);

  return (
    <QAProvider>
      <div className={containerStyles} id={QUESTIONS_FLOW_CONTAINER_ID}>
        <SkuHeader toggleOverlay={toggleOverlay} />
        <Switch>
          <Route path="/cart/add-sku/:skuId/:question?" render={() => {
            return (
                <QuestionAnswerDisplay/>
            )
          }} />

          <Route><QuestionAnswerDisplay/></Route>
        </Switch>
        <DarkOverlay absolute show={showOverlay} className={styles.darkOverlay} />
      </div>
    </QAProvider>
  );
};

export default QuestionsFlowPage;
